import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface ThemeState {
  theme: 'light' | 'dark';
  toggleTheme: () => void;
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set, get) => ({
      theme: 'dark', // default to dark — matches NotForProfit
      toggleTheme: () => {
        const next = get().theme === 'dark' ? 'light' : 'dark';
        set({ theme: next });
        applyTheme(next);
      },
    }),
    {
      name: 'eap-theme',
      onRehydrateStorage: () => (state) => {
        if (state) applyTheme(state.theme);
      },
    },
  ),
);

function applyTheme(theme: 'light' | 'dark') {
  if (typeof document === 'undefined') return;
  document.documentElement.classList.toggle('dark', theme === 'dark');
}

// Apply persisted theme synchronously at module load to avoid (a) flash and
// (b) overwriting the user's rehydrated choice with a hardcoded default.
if (typeof document !== 'undefined') {
  let initial: 'light' | 'dark' = 'dark';
  try {
    const raw = localStorage.getItem('eap-theme');
    if (raw) {
      const stored = JSON.parse(raw)?.state?.theme;
      if (stored === 'light' || stored === 'dark') initial = stored;
    }
  } catch {
    // localStorage unavailable — fall through to default
  }
  applyTheme(initial);
}
